module.exports = __webpack_public_path__ + "img/26.3.TP.acc1b9e2.png";